import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';

export default function MyAddresses() {
  const [addrs, setAddrs] = useState(null);

  useEffect(() => {
    axios.get('/api/customer/addresses').then(r => setAddrs(r.data)).catch(() => {});
  }, []);

  const copy = (text, label) => {
    navigator.clipboard.writeText(text).then(() => toast.success(`${label} copied!`)).catch(() => {
      const el = document.createElement('textarea');
      el.value = text;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      toast.success(`${label} copied!`);
    });
  };

  const AddressCard = ({ flag, country, address, shippingMark }) => (
    <div className="card" style={{ marginBottom: 16 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
        <span style={{ fontSize: 28 }}>{flag}</span>
        <div>
          <p style={{ fontWeight: 700, fontSize: 15 }}>{country} Warehouse</p>
          <p style={{ fontSize: 12, color: '#6b7280' }}>Use this address when shopping</p>
        </div>
      </div>
      <div style={{ background: '#f8fafc', borderRadius: 8, padding: 12, marginBottom: 10, fontFamily: 'monospace', fontSize: 13, lineHeight: 1.6, whiteSpace: 'pre-line' }}>
        {address}
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <button onClick={() => copy(address, 'Address')} className="btn btn-outline btn-sm" style={{ flex: 1 }}>📋 Copy Address</button>
        <button onClick={() => copy(shippingMark, 'Shipping mark')} className="btn btn-primary btn-sm" style={{ flex: 1 }}>🏷️ Copy Mark</button>
      </div>
    </div>
  );

  return (
    <div>
      <div className="page-header">
        <Link to="/home" className="back-btn">←</Link>
        <h1>My Addresses 🏠</h1>
      </div>
      <div className="page-content">
        <div className="card" style={{ background: '#fffbeb', border: '1px solid #fef3c7' }}>
          <p style={{ fontSize: 13, color: '#92400e' }}>⚡ <strong>Your Shipping Mark:</strong> {addrs?.shipping_mark}</p>
          <p style={{ fontSize: 12, color: '#92400e', marginTop: 4 }}>Always include your shipping mark when placing orders so we can identify your goods.</p>
        </div>
        {addrs ? (
          <>
            <AddressCard flag="🇨🇳" country="China (CN)" address={addrs.cn_address} shippingMark={addrs.shipping_mark} />
            <AddressCard flag="🇹🇷" country="Turkey (TR)" address={addrs.tr_address} shippingMark={addrs.shipping_mark} />
          </>
        ) : <div className="loading-center"><div className="spinner spinner-dark" /></div>}
      </div>
    </div>
  );
}
